import { SIGNUP_USERSESSION } from "../../setup/actions";

function buildIframeUrl(url, _usersession_id) {
    url = replaceUrlParam(url, 'usersession', _usersession_id);
    return url;
}

function replaceUrlParam(url, paramName, paramValue) {
    if (url.indexOf('#') == 0 || url.indexOf("javascript") > -1)
        return url;
    var pattern = new RegExp('(' + paramName + '=).*?(&|$)');
    var newUrl = url;
    if (url.search(pattern) >= 0) {
        newUrl = url.replace(pattern, '$1' + paramValue + '$2');
    }
    else {
        newUrl = newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
}

function smSourceAuthCheck(popup) {

    const smAuthInterval = new Promise((resolve, reject) => {
        const finishedInterval = setInterval(() => {
            if (!popup || !popup.closed) {
                return;
            }
            const sourceAuthStatus = localStorage.getItem("sm_sourcauth_status");
            clearInterval(finishedInterval);
            if (!sourceAuthStatus) {
                reject('signInClosed');
                console.log("sourceAuthStatus not found, user closed the window without signin");
            }
            localStorage.removeItem("sm_sourcauth_status");
            resolve(sourceAuthStatus);
        }, 250);
    });

    return smAuthInterval;
}

function getUsersessionFromLocalStorage(){
    return localStorage.getItem(SIGNUP_USERSESSION);
}

export { 
    buildIframeUrl ,
    smSourceAuthCheck,
    getUsersessionFromLocalStorage
}